export default __webpack_public_path__ + "static/media/05_DAIF_UseCase_04_02.5378a46b.mp4";